import React from 'react'
import { SVGIconProps } from '../types'
const SvgExposurePlus2 = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0zm0 0h24v24H0z" />
    <path d="m16.05 16.29 2.86-3.07c.38-.39.72-.79 1.04-1.18s.59-.78.82-1.17q.345-.585.54-1.17c.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46q-.27-.66-.78-1.11c-.34-.31-.77-.54-1.26-.71A5.7 5.7 0 0 0 17.47 5c-.69 0-1.31.11-1.85.32s-1 .51-1.36.88c-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49s.6-.18.96-.18q.465 0 .81.15c.23.1.43.25.59.43s.28.4.37.65c.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7s-.32.53-.56.83c-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71zM8 7H6v4H2v2h4v4h2v-4h4v-2H8z" />
  </svg>
)
export default SvgExposurePlus2
